import "./LinkEmployeesInfoSetupFieldsPanelStyle.css";

import { Grid } from "@mui/material";
import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedDropDownRHFWithLabel,
	LabelPosition,
	RHookFormDatePicker,
} from "@websential/cosmic-v20";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";

import { FC, useEffect, useState } from "react";

interface ILinkEmployeesInfoSetupFieldsPanel {
	employeeDDL: any;
	linkedEmployeesDDL: any;
	onLinkedEmployeesClickedHandler: () => void;
	importDataPageName: string;
	onLinkEmployeesTableChange: (data: any[]) => void;
	linkEmployeesFieldsData: any;
}



export const LinkEmployeesInfoSetupFieldsPanel: FC<
	ILinkEmployeesInfoSetupFieldsPanel
> = ({ employeeDDL, linkedEmployeesDDL,
	importDataPageName,
	onLinkEmployeesTableChange,
	linkEmployeesFieldsData,
	onLinkedEmployeesClickedHandler,
}) => {
		const columns = [
			{ field: "employeeId", headerName: "SimplePay Employee(s)" },
			{
				field: "addOnsEmployeeId", headerName: importDataPageName === "zoho_people" ? "Zoho People Employee(s)"
					: importDataPageName === "bamboo_hr" ? "BambooHR Employee(s)" : "When I Work Employee(s)",
			},
		];

		const [linkEmployeesTable, setLinkEmployeesTable] = useState(linkEmployeesFieldsData);

		useEffect(() => {
			setLinkEmployeesTable(linkEmployeesFieldsData);
		}, [linkEmployeesFieldsData]);

		useEffect(() => {
			onLinkEmployeesTableChange(linkEmployeesTable);
		}, [linkEmployeesTable]);

		const onCellValueChange = (event: any, rowIndex: number, field: any) => {
			setLinkEmployeesTable((prev: any) => {
				const updatedData = [...prev];
				const updatedRow = { ...updatedData[rowIndex], [event.field]: field };
				updatedData[rowIndex] = updatedRow; // ✅ Replace with new object (triggers re-render)
				return updatedData;
			});
		};
		const columnsBody = (rowData: any, row: any, x: any) => {
			if (x.field === "employeeId") {
				return (
					<Dropdown
						options={employeeDDL ?? []}
						value={rowData.employeeId}
						onChange={(e: any) =>
							onCellValueChange(x, row.rowIndex, e.value)
						}
						optionLabel="label"
						optionValue="value"
						style={{ borderRadius: "2px", fontSize: "0.875rem" }}
					/>
				);
			}
			if (x.field === "addOnsEmployeeId") {
				return (
					<Dropdown
						// options={linkedEmployeesDDL ?? []}
						options={rowData.addOnsEmployeeOptions ?? linkedEmployeesDDL ?? []}
						value={rowData.addOnsEmployeeId}
						onChange={(e: any) =>
							onCellValueChange(x, row.rowIndex, e.value)
						}
						optionLabel="label"
						optionValue="value"
						placeholder="--"
						style={{ borderRadius: "2px", fontSize: "0.875rem" }}
					/>
				);
			}
		};

		return (
			<>
				<Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
					<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} sx={{ marginBottom: "1rem" }} >
						<span style={{ height: "10px", width: "10px", background: "#ccffd1" }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;
						<span style={{ color: "#c0c0c0", fontSize: ".775rem", margin: "5px" }}>
							Already Linked Employee(s)
							To delink SimplePay employee with When I Work, select employee in SimplePay column and select (--) in When I Work column and press Link Employee(s) button.
						</span>
					</Grid>
				</Grid>

				<DataTable
					// value={tableData}
					value={linkEmployeesTable}
					// dataKey="id"
					showGridlines
					className="LinkedEmployeesFieldsStyle"
					columnResizeMode="expand"
					scrollable
					filterDisplay="menu"
					scrollHeight="516px"
				>
					{columns.map((x: any) => (
						<Column
							key={x.field}
							field={x.field}
							header={x.headerName}
							columnKey={x.field}
							style={{
								fontSize: "0.875rem",
							}}
							body={(rowData, row) =>
								columnsBody(rowData, row, x)
							}
						/>
					))}
				</DataTable>

				<Grid sx={{ marginBottom: "1rem" }}></Grid>
				<EnhancedButtonPrimeReact
					label="Link Employee(s)"
					raised
					severity={EnhancedButtonPrimeReactSeverity.Secondary}
					// onClickHandler={() => handleImportClick("link_employees")}
					onClickHandler={() => onLinkedEmployeesClickedHandler()}
				/>
			</>
		);
	};
